import types from './types';
import cartActions from './CartAction';

const initState = {
    loader: false,
    data: [],
    // addressData: [],
    relatives: [],
    limit: 10,
    skip: 0,
    count: 0
};

export default function cartReducer(state = initState, action) {
    switch (action.type) {

        case types.GET_CART_ITEMS:
            return {
                ...state,
                loader: true,
            };

        case types.GET_CART_ITEMS_SUCCESS:
            return {
                ...state,
                loader: false,
                data: action.payload,
                // count: action.count,
            };

        // case types.GET_DELIVERY_ADDRESS:
        //     return {
        //         ...state,
        //         loader: true,
        //     };

        case types.GET_RELATIVE:
            return {
                ...state,
                loader: true,
            };
        case types.GET_RELATIVE_SUCCESS:
            return {
                ...state,
                loader: false,
                relatives: action.payload,
                // count: action.count,
            };

        // case types.GET_DELIVERY_ADDRESS_SUCCESS:
        //     return {
        //         ...state,
        //         loader: false,
        //         addressData: action.payload,
        //         // count: action.count,
        //     };

        case types.CLEAR_CART:
            return {
                data: [],
                // count: action.count,
            };


        default:
            return state;
    }
}
